<template>
<div>
  <t-breadcrumb
    :title="title"
    :title-button="titleButton"
    :hide-back="hideBack"
    @action="actionButton"
  />
  <div class="ui container">
    <div class="wrapper-campaign">
      <t-table-campaign />
    </div>
  </div>
 </div>
</template>

<script>
export default {
  components: { TTableCampaign: () => import('@/components/tables/campaign') },

  data () {
    return {
      title: "Campanhas",
      titleButton: "Nova campanha",
      hideBack: true,
    }
  },

  methods: {
    actionButton () {
      this.$router.push('campaign/new')
    },
  }
}
</script>

<style lang="scss">
.wrapper-campaign {
  margin-top: 70px;
  margin-bottom: 70px;

  .wrapper-file-empty {
    height: calc(100vh - 160px) !important;

    .title {
      margin-bottom: 0px !important;
    }
  }
}
</style>
